import React from 'react';
import { AppSettings } from './../../config/app-settings.jsx';

function Content(props) {
	return (
		<AppSettings.Consumer>
			{({ appContentClass }) => (
				((appContentClass !== '') ? 
					<div className={'app-content ' + appContentClass}>
						{props.children}
					</div> : props.children)
			)}
		</AppSettings.Consumer>
	)
}

export default Content;
